var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mc-loading"},[_vm._t("default"),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"mc-loading__animation"},[_vm._m(0)]):_vm._e()],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mc-loading__box"},[_c('i',{staticClass:"mc-loading__i"}),_vm._v(" "),_c('p',[_vm._v("loading")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


// WEBPACK FOOTER //
// ./src/components/base-loading.vue